import Vue from 'vue';
import Vuex from 'vuex';
import depart from './modules/depart';
import dictionary from './modules/dictionary';
import user from './modules/user';
import base from './modules/base';
import role from './modules/role';
import sys from './modules/sys';
import business from './modules/business';

Vue.use(Vuex);

export default new Vuex.Store({
  // strict: process.env.NODE_ENV !== 'production',
  strict: false,
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    depart,
    dictionary,
    base,
    user,
    role,
    business,
    sys
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js